// ----------------------------------------------------------------------

const account = {
  displayName: 'Tiago-Jayee Samuel',
  email: 'tjs@aster.com',
  photoURL: '/static/mock-images/avatars/avatar_default.jpg'
};

export default account;
